import moment from 'moment';

const structureBasic = class structureBasic{
	constructor(question) {
		const {name, type, label, required, inputType, related} = question;	

		if(related)	{
			if(inputType) return {name, type, label, required, inputType, help: question.help?question.help:'', related};
			return {name, type, label, required, help: question.help?question.help:'', related};			
		}else {
			if(inputType) return {name, type, label, required, inputType, help: question.help?question.help:''};
			return {name, type, label, required, help: question.help?question.help:''};			
		}		
	}
}

const Default = class Default extends structureBasic {  //default, textarea
	constructor(question) {
		const basic = super(question);
		this.properties= {
	      "min": 0,
	      "max": question.maxLength
	    }
	    
	    let related = {};
	    if(question.related) {
	    	related = question.related;
	    	return {...basic, properties: this.properties, related};
	    }
	    return {...basic, properties: this.properties};
	}
}

const Number_ = class Number_ extends structureBasic { //number, currency
	constructor(question) {
		const basic = super(question);
		const maxLength = question.maxLength;
		let min = 0;
		if(question.inputType === 'currency') question.maxLength = new Intl.NumberFormat("de-DE").format(question.maxLength);	

		if(question.required) min = 1;
		this.properties= {
	      	"min": min,
	      	"max": String(question.maxLength).length,
	      	"minValue": 1,
        	"maxValue": maxLength
	    }
	    
	    let related = {};
	    if(question.related) {
	    	related = question.related;
	    	return {...basic, properties: this.properties, related};
	    }

	    return {...basic, properties: this.properties};
	}
}

const Email = class Email extends structureBasic {
	constructor(question) {
		const basic = super(question);
		return {...basic, options: ['@gmail.com']};
	}
}

const Barcode = class Barcode extends structureBasic {
	constructor(question) {
		const basic = super(question);
		return {...basic, maxLength: 20};
	}
}

const MultiInput = class MultiInput extends structureBasic {
	constructor(question) {
		const basic = super(question);

		if(question.maxLength) {
			if(question.required) return {...basic, properties:  {"min": 1, "max": question.maxLength}};
			else return {...basic, properties:  {"min": 0, "max": question.maxLength}};
		}else {
			if(question.required) return {...basic,...{'inputType': 'multiInput','type': 'input'}, properties:  {"min": 1, "max": 1}};
			else return {...basic, ...{'inputType': 'multiInput', 'type': 'input'}, properties:  {"min": 0, "max": 1}};
		}
	}
}

const Slider = class Slider extends structureBasic {
	constructor(question) {
		const basic = super(question);
		const properties = {
		      "minValue": question.properties.min,
		      "maxValue": question.properties.max,
		      "default": question.properties.default,
		      "orientation": question.properties.orientation,
		      "color": "#FFFFFF"
		    }
		return {...basic, properties};
	}
}

const Booleane = class Booleane extends structureBasic{
	constructor(question) {
		const basic = super(question);
		return {...basic, ...{inputType: 'standar'}};
	}
}

const Signature = class Signature extends structureBasic {
	constructor(question) {
		const basic = super(question);
		const properties = {
		  "color": "#000000"
		}
		return {...basic, ...{inputType: 'sign'}, properties};
	}
}

const Date_ = class Date_ extends structureBasic {
	constructor(question) {
		const basic = super(question);
		let properties = {};
		let inputType = '';
		const type = 'date';

		if(question.type === 'time' || question.type === 'datetime') {
			inputType = 'time';
			properties = {...{"default": "AM/PM"}, ...properties}
		}

		if(question.type === 'date' || question.type === 'datetime') {
			inputType = question.type === 'date'?'calendar':'datetime';
			properties = {...{
		      "minValue": parseInt(moment().subtract(1,'year').format('YYYY')),
	           "maxValue": parseInt(moment().format('YYYY'))
		    },...properties}
		}		
		return {...basic, ...{inputType, type}, properties};
	}
}

const Label = class Label extends structureBasic {
	constructor(question) {
		const basic = super(question);
		let properties = {};

		switch (question.inputType) {
			case 'label':
				properties = {...question.properties, ...{color: "#000000"}};
				return {...basic, ...{type: 'label', content: '123456789'}, properties};
				break;
			case 'link':
				properties = {color: "#000000",default: "external"};
				return {...basic, ...{type: 'label', content: question.content}, properties};
				break;
			case 'paragraph':
				properties = {default: "all"};
				return {...basic, ...{type: 'label', content: question.content}, properties};
				break;
			default:
				// statements_def
				break;
		}		
	}
}

const Video = class Video extends structureBasic {
	constructor(question) {
		const basic = super(question);
		return {...basic, ...{inputType: 'url', content: question.content}};
	}
}

const ChoiceMultiple = class ChoiceMultiple extends structureBasic {
	constructor(question) {
		const basic = super(question);
		let properties = {};
		let inputType = 'multi';
		if(question.required) {
			properties = {
				"min": 1,
				"max": question.options.length
			}
		}else {
			properties = {
				"min": 0,
				"max": question.options.length
			}
		}

		if(question.inherited) {
			properties.default = 'Otro, cual?';
			inputType = 'multiOther';
		}

		return {...basic, ...{type: 'choice', inputType, properties, options: question.options}}
	}
}

const ChoiceUnique = class ChoiceUnique extends structureBasic {
	constructor(question) {
		const basic = super(question);		
		let properties = {default: "radio"};
		let inputType = 'radio';

		if(question.inherited) {
			properties.default = 'Otro, cual?';
			inputType = 'radioOther';			
		}

		return {...basic, ...{type: 'choice', inputType, properties, options: question.options}}
	}
}

const Geo = class Geo extends structureBasic {
	constructor(question) {
		const basic = super(question);
		let properties = {}
		if(question.content) properties = {default: question.content};
		if(question.type === 'location') return {...basic, ...{type: 'geo'}};
		if(question.type === 'map') return {...basic, ...{key: question.key}};
		return {...basic, ...{key: question.key, properties}}
	}
}

const Viewer = class Viewer extends structureBasic {
	constructor(question) {
		return {...question, ...{help: question.help?question.help:''}};
	}
}

const converToFormV2 = (json) => {
	return json.map(question => {
				let result = converToNewJson(question);				
				return result;
			})
}

const converToNewJson = (question) => {
	if(question.inputType) {
		return isHasInputType(question);
	}else {
		return isHasType(question);
	}
}

const isHasInputType = (question) => {
	switch (question.inputType) {
		case 'default':
		case 'textarea':
			return new Default(question);
			break;
		case 'number':
		case 'currency':
			return new Number_(question);
			break;
		case 'email':
			return new Email(question);
			break;
		case 'barcode':
			return new Barcode(question);
			break;		
		case 'checktext':
			return new MultiInput(question);
			break;
		case 'slider':
			return new Slider(question);
			break;
		case 'label':
		case 'link':
		case 'paragraph':
			return new Label(question);
			break;
		case 'radio':							
			return new ChoiceUnique(question);
			break;												
		default:
			return this.isHasType(question);
			break;
	}
}

const isHasType = (question) => {
	switch (question.type) {
		case 'multiInput':
			return new MultiInput(question);
			break;
		case 'boolean':							
			return new Booleane(question);
			break;
		case 'signature':							
			return new Signature(question);
			break;
		case 'time':
		case 'date':
		case 'datetime':							
			return new Date_(question);
			break;
		case 'video':							
			return new Video(question);
			break;
		case 'multiChoice':
			return new ChoiceMultiple(question);
			break;
		case 'geo':
		case 'map':
		case 'location':
			return new Geo(question);
			break;
		case 'viewer':
		case 'photo':
			return new Viewer(question);
			break;						
		default:
			// statements_def
			break;
	}
}

export { converToFormV2 };
